import React, { Component } from 'react'

class MicroSpinner extends Component {
  render () {
    return (
      <div className="micro-spinner"></div>
    )
  }
}

export default MicroSpinner
